<template>
  <div class="messageBox">
      <div class="message">{{msg}}</div>
  </div>
</template>

<script>
export default {
    name:'Message',
    props:{
        msg:{
          type:String,
          default:'这是提示'
        },
        isShowMessage:{
          type:Boolean,
          default:false
        }

    },
    watch:{
        isShowMessage:function(newVal){
            console.log('message',newVal)
            const that = this;
            // that.isShowMessage = !that.isShowMessage;
            setTimeout(function(){
                that.$emit('isShowMsg',false)
            },1000)
        }
    },
    data(){
        return{
           
        }
    },
}
</script>

<style scoped>
    .messageBox{
        width:100%;
        height: 100%;
        z-index: 9999;
        position: fixed;
        left:0;
        top: 0;
    }
    .message{
        min-width:100px;
        position: absolute;
        left: 50%;
        top:50%;
        transform: translate(-50%,-50%);
        background: rgba(0,0,0,.4);
        color:white;
        text-align: center;
        z-index: 1000;
        padding: 10px 20px;
        border-radius: 5px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Message/Message.vue